var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActualSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FAF119"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3542_11732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6357 22.2401C21.0617 21.2961 19.9124 20.3281 19.9124 18.8081C19.9124 17.0641 21.4947 15.8401 24.1633 15.8401C26.9658 15.8401 28.0049 17.2001 28.0994 19.2001H31.5788C31.4765 16.4401 29.8155 13.9281 26.525 13.1041V9.6001H21.8017V13.0561C18.7473 13.7361 16.2912 15.7361 16.2912 18.8321C16.2912 22.5281 19.3062 24.3681 23.691 25.4401C27.6349 26.4001 28.4143 27.8001 28.4143 29.3041C28.4143 30.4001 27.6507 32.1601 24.1633 32.1601C20.92 32.1601 19.6369 30.6801 19.4716 28.8001H16C16.1968 32.3041 18.7709 34.2641 21.8017 34.9281V38.4001H26.525V34.9601C29.5872 34.3601 32.0354 32.5601 32.0354 29.2721C32.0354 24.7441 28.2096 23.1921 24.6357 22.2401Z",
    fill: "#161717"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3542_11732",
    x: 12,
    y: 9.6001,
    width: 24.0354,
    height: 36.7998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3542_11732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3542_11732",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActualSales);
export default __webpack_public_path__ + "static/media/actual_sales.afcdf32f33c37b053c15ec252d75047f.svg";
export { ForwardRef as ReactComponent };